/* unplugin-vue-components disabled */import script from "./myCourse_copy.vue?vue&type=script&setup=true&lang=js"
export * from "./myCourse_copy.vue?vue&type=script&setup=true&lang=js"

import "./myCourse_copy.vue?vue&type=style&index=0&id=9b02bef2&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9b02bef2"]])

export default __exports__